import React from 'react';
import '../App.css';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {
  BrowserRouter as Router,

  Link
} from 'react-router-dom'
import Typography from '@mui/material/Typography';
import 'typeface-roboto';

const useStyles = {

  cardRoot: {
    minWidth: 275,
    outlineColor: "#FF0000",
    outlineWidth: 24,
    width: 300,
    borderRadius: 20,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 28,
    fontWeight: 'bolder',
    color: '#D32F2F'
  },
  pos: {
    marginBottom: 12,
  },
};

function NotFound() {
  const classes = useStyles;
  return (

    <header className="App-header" style={{ shadows: ["none"], padding: 2, background: '#212121', backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>

      <Card styles={classes.cardRoot} variant="outlined">
        <CardContent style={{ minWidth: 300, padding: 10, borderRadius: 20 }}>
          <h3> Oops!</h3>
          <h4>


            Page Not Found
              </h4>
          <Link to="/" style={{ textDecoration: "none" }}>
            <Button variant="contained" color="secondary" style={{ padding: 6, margin: 4 }} >Go To Homepage</Button>
          </Link>
        </CardContent>

      </Card>

    </header>

  );
}

export default NotFound;